/**
 * The link card of a post being written or edited, as the post will show it — a link card, a YouTube player or
 * an image — with a ✕ to remove it (useLinkPreview's dismissCard). Used by the composer and the post editor.
 */
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { SafeImage } from 'components/collab/lab/LabMarkdown';
import { linkedImageOf } from 'shared/helpers/postText';
import { parseYouTube } from 'shared/helpers/youtube';
import LinkPreviewCard from './LinkPreviewCard';
import YouTubeEmbed from './YouTubeEmbed';

export default function EditableLinkPreview({ linkPreview, previewLoading, onDismiss }) {
  if (!linkPreview && !previewLoading) return null;
  return (
    <Box sx={{ px: 0, mt: 1 }}>
      {previewLoading ? (
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>Fetching preview…</Typography>
      ) : linkedImageOf(linkPreview) ? (
        // a link to an image: the image, as it appears at the bottom of the post
        <Box sx={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
          <SafeImage src={linkedImageOf(linkPreview)} alt="" />
          <IconButton size="small" aria-label="Remove the image preview" onClick={onDismiss}
            sx={{ position: 'absolute', top: 14, right: 6, color: '#fff', bgcolor: 'rgba(0,0,0,0.55)', '&:hover': { bgcolor: 'rgba(0,0,0,0.75)' } }}>
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      ) : parseYouTube(linkPreview.url) ? (
        // a YouTube link previews as the player the post shows
        <YouTubeEmbed video={parseYouTube(linkPreview.url)} title={linkPreview.title} onDismiss={onDismiss} />
      ) : (
        <LinkPreviewCard preview={linkPreview} onDismiss={onDismiss} />
      )}
    </Box>
  );
}
